import { MutationTree } from 'vuex';
import { ApplicationsState, ApplicationsData, ApplicationDetails } from './types';

const mutations: MutationTree<ApplicationsState> = {
  setJob(state, job: ApplicationsData) {
    state.job = job;
  },

  setAllStatusTotal(state, allStatusTotal: ApplicationsData) {
    state.allStatusTotal = allStatusTotal;
  },

  setReceivedTotal(state, receivedTotal: ApplicationsData) {
    state.receivedTotal = receivedTotal;
  },

  setInterestedTotal(state, interestedTotal: ApplicationsData) {
    state.interestedTotal = interestedTotal;
  },

  setNotAFitTotal(state, notAFitTotal: ApplicationsData) {
    state.notAFitTotal = notAFitTotal;
  },

  setApplicationDetails(state, applicationDetails: ApplicationDetails) {
    state.applicationDetails = applicationDetails;
  },

  setMessageSentNotification(state, changeTo: boolean) {
    state.showMessageSentNotification = changeTo;
  },

  setToastNotificationMessage(state, changeTo: string) {
    state.toastNotificationMessage = changeTo;
  },

  setShowApplicationLoading(state, changeTo: boolean) {
    state.showApplicationLoading = changeTo;
  },

  setRemoveApplicantFromList(state) {
    const currentAppId: string = state.applicationDetails.id;
    const newEdges = state.job.applications.edges.filter(({ node }: { node: { id: string } }) => node.id !== currentAppId);

    state.job = {
      ...state.job,
      ...{
        applications: {
          edges: newEdges,
          totalCount: state.job.applications.totalCount,
        },
      },
    };
  },
};

export default mutations;
